import { ApiAddress } from '@/services/apis'
import request from '@/services/request'
import { Dimension } from './dimension.model'

export function loadDimensions(): Promise<Dimension.Info[]> {
  return request.get(ApiAddress.DIMENSIONS)
}

export function loadDimension(id): Promise<Dimension.Info> {
  return request.get(ApiAddress.DIMENSION, { params: { id } })
}

export function createDimension(body): Promise<Dimension.Info> {
  return request.post(ApiAddress.DIMENSIONS, body)
}

export function updateDimension(id, body) {
  return request.put(ApiAddress.DIMENSION, body, { params: { id } })
}

export function deleteDimension(id) {
  return request.delete(ApiAddress.DIMENSION, { params: { id } })
}

export function addDimensionUnit(id, body) {
  return request.post(ApiAddress.DIMENSION_UNITS, body, { params: { id } })
}

export function updateDimensionUnit(id, uid, body) {
  return request.put(ApiAddress.DIMENSION_UNIT, body, { params: { id, uid } })
}

export function deleteDimensionUnit(id, uid) {
  return request.delete(ApiAddress.DIMENSION_UNIT, { params: { id, uid } })
}
